import { render } from "./VConsole.vue?vue&type=template&id=15032b16"
import script from "./VConsole.vue?vue&type=script&lang=js"
export * from "./VConsole.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__